import api from '@/apiManager/apiManager'

// Community admin notifications (microservices: apps/corporate-admin/src/notifications).
// Responses use the standard envelope: { statusCode, message, data, meta? }.

const toQuery = params => {
  const query = new URLSearchParams()
  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') query.append(key, value)
  })
  const text = query.toString()
  return text ? `?${text}` : ''
}

export const getNotifications = params => api('get', `/corporate-admin/notifications${toQuery(params)}`, '', 'base')

export const getUnreadNotificationCount = () => api('get', '/corporate-admin/notifications/unread-count', '', 'base')

// The people in one notification (the "View all" pop-up).
export const getNotificationActors = (id, params) => api(
  'get',
  `/corporate-admin/notifications/${id}/actors${toQuery(params)}`,
  '',
  'base',
)

// Community joins: the challenges / classes / groups people joined through.
export const getNotificationSources = (id, params) => api(
  'get',
  `/corporate-admin/notifications/${id}/sources${toQuery(params)}`,
  '',
  'base',
)

// Read state is shared by every admin of the community.
export const markNotificationRead = id => api('patch', `/corporate-admin/notifications/${id}/read`, {}, 'base')

export const markAllNotificationsRead = category => api(
  'patch',
  `/corporate-admin/notifications/read-all${toQuery({ category })}`,
  {},
  'base',
)

// Settings are per community and shared by all its admins (plan §9.8).
export const getNotificationSettings = () => api('get', '/corporate-admin/notifications/settings', '', 'base')

export const updateNotificationSettings = data => api('patch', '/corporate-admin/notifications/settings', data, 'base')
